/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Ujjwal Singh >

*/
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from "react";
import { NavLink as RouterLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { List, ListItem, Button, colors } from "@material-ui/core";
import LockOpenIcon from "@material-ui/icons/Lock";
import HelpIcon from '@material-ui/icons/Help';
// offlinedb
import { getUsers, deleteUser } from "database/offlineDb/indexDb";
// action
import { updateLogOutModel,updateHelpMenuModel } from "actions/global-action";
//theme
import palette from "theme/palette";
const themeName = "orangeTheme";

const useStyles = makeStyles((theme) => ({
 root: {},
 item: {
  display: "flex",
  paddingTop: 0,
  paddingBottom: 0,
  color: "#efefef",
 },
 button: {
  display: "block",
  textAlign: "center",
  color: theme.palette.black,
  padding: "10px 8px",
  textTransform: "none",
  letterSpacing: 0,
  width: "100%",
  minWidth: "20px",
  fontWeight: theme.typography.fontWeightMedium,
  "& $icon": {
   color: theme.palette.black,
  },
 },
 MenuItem: {
  display: "flex",
  // color: "#aeaeae",
 },
 icon: {
  // display:'block',
  // width: 24,
  // height: 24,
  marginRight: theme.spacing(1),
  fontSize: "1em",
 },
 active: {
  background: theme.palette.action.active,
  color: theme.palette.white,
  fontWeight: theme.typography.fontWeightMedium,
  "& $icon": {
   color: theme.palette.white,
  },
  "&:hover": {
   background: theme.palette.action.active,
  },
 },
}));

const CustomRouterLink = forwardRef((props, ref) => (
 <div ref={ref} style={{ flexGrow: 1 }}>
  <RouterLink {...props} />
 </div>
));

const SidebarNav = (props) => {
 const { pages, className, ...rest } = props;
 const [isOpenModel, setIsOpenModel] = React.useState(false);

 const classes = useStyles();
 const handleLogout = () => {
  props.updateLogOutModel(true);
 };
 const handleHelpMenu=()=>{
    props.updateHelpMenuModel(true);
 }
 return (
  <List {...rest} className={clsx(classes.root, className)}>
   {pages.map((page) => (
    <ListItem className={classes.item} disableGutters key={page.title}>
     <Button
      activeClassName={classes.active}
      className={classes.button}
      component={CustomRouterLink}
      to={page.href}
     >
      {props.sidebarMini ? (
       <span
        className={classes.MenuItem}
        style={{
         flexDirection: "column",
         justifyContent: "center",
         fontSize: "11px",
        }}
       >
        <div className={classes.icon} style={{ marginRight: "0" }}>
         {page.icon}
        </div>
        <div>{page.title}</div>
       </span>
      ) : (
       <span
        className={classes.MenuItem}
        style={{ flexDirection: "row", justifyContent: "start" }}
       >
        <div className={classes.icon}>{page.icon}</div>
        <div>{page.title}</div>
       </span>
      )}
     </Button>
    </ListItem>
   ))}

<ListItem className={classes.item} disableGutters key="logout"><ListItem
    className={classes.item}
    disableGutters
    // key={page.title}
   >
    <Button
     activeClassName={classes.active}
     className={classes.button}
     // component={CustomRouterLink}
     // to={page.href}
     onClick={handleHelpMenu}
    >
     {props.sidebarMini ? (
      <span
       className={classes.MenuItem}
       style={{
        flexDirection: "column",
        justifyContent: "center",
        fontSize: "11px",
       }}
      >
       <div className={classes.icon} style={{ marginRight: "0" }}>
        <HelpIcon />
       </div>
       <div>Help Menu</div>
      </span>
     ) : (
      <span
       className={classes.MenuItem}
       style={{ flexDirection: "row", justifyContent: "start" }}
      >
       <div className={classes.icon}>
        <HelpIcon />
       </div>
       <div>Help Menu</div>
      </span>
     )}
    </Button>
   </ListItem></ListItem>

   <ListItem
    className={classes.item}
    disableGutters
    // key={page.title}
   >
    <Button
     activeClassName={classes.active}
     className={classes.button}
     // component={CustomRouterLink}
     // to={page.href}
     onClick={handleLogout}
    >
     {props.sidebarMini ? (
      <span
       className={classes.MenuItem}
       style={{
        flexDirection: "column",
        justifyContent: "center",
        fontSize: "11px",
       }}
      >
       <div className={classes.icon} style={{ marginRight: "0" }}>
        <LockOpenIcon />
       </div>
       <div>Logout</div>
      </span>
     ) : (
      <span
       className={classes.MenuItem}
       style={{ flexDirection: "row", justifyContent: "start" }}
      >
       <div className={classes.icon}>
        <LockOpenIcon />
       </div>
       <div>Logout</div>
      </span>
     )}
    </Button>
   </ListItem>
   

  </List>
 );
};

SidebarNav.propTypes = {
 className: PropTypes.string,
 pages: PropTypes.array.isRequired,
};
function mapStateToProps(store) {
 return {
  globalStore: store.globalStore,
  patientStore: store.patientStore,
 };
}
export default connect(mapStateToProps, { updateLogOutModel,updateHelpMenuModel })(
 withRouter(SidebarNav)
);
// export default ;
